import { useCallback } from 'react';
import { SelectGame } from '../../components/organizer/new-event-wizard/SelectGame';
import { useWizardDialog } from '../wizard/useWizardDialog';
import { SelectCreationMethod } from '../../components/organizer/new-event-wizard/SelectCreationMethod';
import { SelectEventType } from '../../components/organizer/new-event-wizard/SelectEventType';
import { CreateEventProvider } from '../../contexts/organizer/create-event/CreateEventContext';
import { CopyEvent } from '../../components/organizer/new-event-wizard/CopyEvent';
import { CreateEvent } from '../../components/organizer/new-event-wizard/CreateEvent';
import { EventFrequency } from '../../components/organizer/new-event-wizard/EventFrequency';

export type CreateEventStore = {
  gameId: string;
  eventType: 'Tournament' | 'Giveaway';
  eventId: string;
  method: 'create' | 'copy';
};

export function useCreateEventWizard() {
  const { open: openWizardDialog } = useWizardDialog();
  const open = useCallback(
    (
      startPage: 'Select Game' | 'Create Event' = 'Select Game' as const,
      props?: any,
    ) => {
      const storeDefault = {
        gameId: 'magiccraft',
        eventType: 'copy',
        eventId: '',
        method: '',
      };

      openWizardDialog({
        storeDefault,
        elements: {
          'Select Game': <SelectGame />,
          'Select Creation Method': <SelectCreationMethod />,
          'Select Event Type': <SelectEventType />,
          'Copy Event': <CopyEvent />,
          'Create Event': <CreateEvent />,
          'Event Frequency': <EventFrequency />,
        },
        elementIdEntry: startPage,
        Wrapper: <CreateEventProvider {...props} />,
      });
    },
    [openWizardDialog],
  );
  return { open };
}
